export default __webpack_public_path__ + "static/media/unfriend.66f8c3c0.svg";